import { useEffect, useState } from 'react'
import { axiosInstance } from 'service/api/axios'

import { Logs, useFetchLog } from './useFetchLog'

export const useSseLog = () => {
    const [initializing, setInitializing] = useState(true)
    const [logs, setLogs] = useState<Logs[]>([])
    const path = new URL(axiosInstance.defaults.baseURL + '/v1/logs/sse')

    const { isLoading, isFetched } = useFetchLog({
        queryParams: {
            clienteId: null,
            operacao: null,
        },
        onSuccess: data => {
            setLogs(data)
            setInitializing(false)
        },
        enabled: initializing,
    })

    useEffect(() => {
        if (!initializing) return

        const eventSource = new EventSource(path.toString())

        eventSource.onmessage = event => {
            const response = JSON.parse(event.data)
            const data = JSON.parse(response.data)

            setLogs(logs => {
                const newLogs = data.filter((log: Logs) => {
                    return !logs.find(({ id }) => id === log.id)
                })

                return [...logs, ...newLogs]
            })
        }

        return () => {
            eventSource.close()
        }
    }, [isFetched])

    return {
        data: logs,
        isLoading,
    }
}
